import { handleActions } from 'redux-actions'

export const defaultState = {
  submittingCopyAssortment: false,
}

const reducer = handleActions(
  {
    'COPY_ASSORTMENT/BEGIN_COPY': (state) => ({
      ...state,
      submittingCopyAssortment: true,
    }),
    'COPY_ASSORTMENT/END_COPY': (state) => ({
      ...state,
      submittingCopyAssortment: false,
    }),
  },
  defaultState,
)

export default reducer
